import React from 'react';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants';
import ArticleLeadCaption from '../ArticleLeadCaption/ArticleLeadCaption';
import s from './LeadImageWithCaption.scss';

const LeadImageWithCaption = props => {
  const {
    preloadedLeadImageHref,
    image,
    resizemode,
    imageAlt,
    hl,
    isMspArticle,
    syn,
    height,
    width = '400',
  } = props;

  return (
    <>
      <figure className={s.leadImageFigure}>
        <div className={s.content}>
          <img
            src={
              preloadedLeadImageHref ||
              `${TOI_IMAGE_DOMAIN}/thumb/msid-${image.id}${
                image.imagesize ? `,imgsize-${image.imagesize}` : ''
              },width-${width}${
                height ? `,${height}` : ''
              },resizemode-${resizemode}/${image.id}.jpg`
            }
            alt={hl || imageAlt || 'banner img'}
            title={image.cap}
          />
        </div>
      </figure>
      <ArticleLeadCaption
        imgCaption={isMspArticle ? syn : image.cap}
        styleObj={s}
        isWapView
        isMspArticle={isMspArticle}
      />
    </>
  );
};

export default LeadImageWithCaption;
